import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EditorService } from '../../bookeditoption/editor.service'
@Component({
  selector: 'app-pallete',
  templateUrl: './pallete.component.html',
  styleUrls: ['./pallete.component.css']
})
export class PalleteComponent implements OnInit {
  @Input() paletteObj: any;
  @Input() data: any;
  @Output() onSelectDrawingClr = new EventEmitter<string>();
  public paletteLeft: any;
  public paletteTop: any;
  public selectedColor: string;
  public thickness: number;
  public opacity = 1;
  public canvasProps;
  public opacityList: any;
  public selOpacityInd: any;


  constructor(private editorService: EditorService) {

  }

  ngOnInit() {

    this.thickness = 1;
    this.opacityList = [{ 'title': '25%', 'value': 0.25 }, { 'title': '50%', 'value': 0.50 }, { 'title': '75%', 'value': 0.75 }, { 'title': '100%', 'value': 1 }];
    this.canvasProps = { 'color': this.selectedColor, 'thickness': this.thickness, 'opacity': this.opacity };

  }

  applyThickness() {
    this.canvasProps = { 'color': this.selectedColor, 'thickness': this.thickness, 'opacity': this.opacity };
    this.onSelectDrawingClr.emit(this.canvasProps);
  }
  applyOpacity(val, index) {
    this.opacity = val;
    this.selOpacityInd = index;
    this.canvasProps = { 'color': this.selectedColor, 'thickness': this.thickness, 'opacity': this.opacity };
    this.onSelectDrawingClr.emit(this.canvasProps);
  }
  // getEditorReference() {
  //   let iframe: any = document.getElementById('pageContainer');
  //   if (iframe) {
  //     let iframeDoc: any = iframe.contentWindow.document;
  //     let layer: any = iframeDoc.Layer;
  //     return layer;
  //   }
  // }
  handleChangedClr(val) {
    this.selectedColor = val;
    this.canvasProps = { 'color': this.selectedColor, 'thickness': this.thickness, 'opacity': this.opacity };
    this.onSelectDrawingClr.emit(this.canvasProps);
    let layer = this.editorService.getIframeReference();
    if (layer)
      layer.changeColor(val);


  }


}



// WEBPACK FOOTER //
// ./src/app/bookShared/popups/pallete/pallete.component.ts